export const numberFormat = {
    methods: {
        numberFormat(num) {
            if(typeof num == 'string'){
                num = num.replace(/[^0-9]/g, '');
            }
            return new Intl.NumberFormat().format(num);
        }
    },
}